import { PageStyle, ButtonStyle, Button,useTranslation, ClientDashboard, Checkbox, Form, Formik, FormikControl, FormStyle, Image, useEffect, useRouter, useState, clearSWRCache, SelectJobModalAction, ErrorPages, useSWR, CONSTANTS, Loading, InputError, InputText, useRef, components, Tooltip, DefaultCheckbox, HoverCheckbox, CheckedCheckbox, DisabledCheckbox, SELECT_JOB_VALIDATION } from '@/imports-files/components/model/select-job-modal';
import { FormModalStyle } from "@/imports-files/components/common-modal/common-modal";
import Modal from "../common-modal/modal";

export function SelectJobModal(props)
{
  const {t} = useTranslation()
  clearSWRCache('import-previous-application')
   const [apiError, setApiError]            =   useState(null);
   const router                             =   useRouter();
   const errorPages                         =   new ErrorPages()
   const [initialValues, setInitialValues]  =   useState({})
   const [ isLoading, setLoading]           =   useState(true);
  const [flagForRerender, setFlagForRerender] =   useState(0);
   const [options, setOptions]              =   useState({})
  const formRef                            =    useRef(null);
  const selectJobRef                        =   useRef(null);
   const [checkboxStep, setCheckboxStep]    =   useState(null)
   const selectJobModalAction               =   new SelectJobModalAction(props.setShowLoader, setApiError, setOptions, checkboxStep, setCheckboxStep, setFlagForRerender, router, props.setButtonPopup, formRef, selectJobRef);
   const { data, error }                    =   useSWR('import-previous-application', () => { return selectJobModalAction.getPreviousJobData({}) });

    useEffect(() =>  {
                        if(data)
                        {   setInitialValues(data.data)
                            setLoading(false)
                            setOptions(selectJobModalAction.dropdownJobOptions(data.data, t))
                            setCheckboxStep({details: false, stages: false, automations: false, scorecards: false, sharing: false})
                        }
                    },[data])  

 
 if(isLoading || error || errorPages.handleErrorCodes(apiError?.status))
  {
    var renderPage  =  (error || apiError) ? errorPages.renderPage(error?.status || apiError?.status, router) : null;
    return renderPage; 
  } 


  return props.buttonPopup ? (
    <Modal
    type="form"
    heading={t('modal:form:import:previous_job:heading')}
    closeModal={(event) => {
      props.setButtonPopup(false)
    }}
    content={
      <>
        <div className={`${FormModalStyle.Modal__Container__ContentSection}`}>
              <h4 className={`${FormModalStyle.Modal__Container__ContentSection__Description}`}>{t('modal:form:import:previous_job:description')}</h4>
              <Formik
                      initialValues={CONSTANTS.formInitialValues}
                      validationSchema = {SELECT_JOB_VALIDATION(t)}
                      innerRef          = {formRef}
                      onSubmit={(values) => {
                                         selectJobModalAction.submitForm(values);
                                     }}>

                        {(formik) => (
              <div className={FormModalStyle.Modal__Container__ContentSection__FormContainer}>
                <Form>
                <div className={`w-100 ${FormStyle.Form__LabelCheck} ${PageStyle.SelectJob__DisplayFlex} Mui__CustomCheckbox`}>
                  <Checkbox
                    onChange = {(event)=> {selectJobModalAction.getArchiveJob(event, t)}}
                    className={'height23'}
                    icon = {<DefaultCheckbox/>}
                    checkedIcon = {<CheckedCheckbox/>}
                    />
                {t('modal:form:import:previous_job:include')}
                </div>

                <div className={`${FormStyle.Form__TableCol} mt30`}>
                  <label className={`${FormStyle.Form__FloatingLabel} mb0`} style = {InputText(formik, "select_job")}>
                    <span className={`red-color`}>*</span> {t('modal:form:import:previous_job:job_title')}</label>

                <div className={`w-100`}>
                    <div className={PageStyle.SelectJob__CustomSelectWidth}>

                          <FormikControl
                               control         =     "select"
                               reference       =     {selectJobRef}
                               formik          =     {formik}
                               name            =     'select_job'
                               className       =     {`${PageStyle.CustomSelect} ${FormStyle.CustomSelect}`}
                               options         =     {options}
                               onChange        =     {(value)=>{formik.setFieldValue('select_job', value?.value)}}
                               style           =     {InputError(formik, "select_job")}
                               components      =     {{GroupHeading}}
                              default          =     {{label:'', values:''}}
                            />

                        </div>
                </div>
             </div>


                <div className={`w-100 ${PageStyle.SelectJob__Checkoptions} mt0`}>
                  <div className={`${PageStyle.SelectJob__DisplayFlex} ${FormStyle.Form__LabelCheck} Mui__CustomCheckbox mb10 ImportSteps`}>
                    <Checkbox name={'details'}
                    onChange={(event)=>{selectJobModalAction.checkboxChange(event, formik)}}
                    value={'details'}
                    icon = {<DefaultCheckbox/>}
                    checkedIcon = {<CheckedCheckbox/>}
                    />
                    {" "}
                    {t('modal:form:import:previous_job:job_details')}
                  </div>

                  <div className={`${PageStyle.SelectJob__DisplayFlex} ${FormStyle.Form__LabelCheck} Mui__CustomCheckbox mb10 ImportSteps`}>
                    <Checkbox name={'details'}
                    onChange={(event)=>{selectJobModalAction.checkboxChange(event, formik)}}
                    value={'options'}
                    icon = {<DefaultCheckbox/>}
                    checkedIcon = {<CheckedCheckbox/>}
                    />
                    {" "}
                    {t('modal:form:import:previous_job:job_options')}
                  </div>

                  <div className={`${PageStyle.SelectJob__DisplayFlex} ${FormStyle.Form__LabelCheck} Mui__CustomCheckbox mb10`}>
                    <Checkbox name={'stages'}
                    onChange={(event)=>{selectJobModalAction.checkboxChange(event, formik)}}
                    value={'stages'}
                    icon = {<DefaultCheckbox/>}
                    checkedIcon = {<CheckedCheckbox/>}
                    />
                    {" "}
                    {t('modal:form:import:previous_job:interview_stages')}
                  </div>

                  <div className={`${PageStyle.SelectJob__DisplayFlex} ${FormStyle.Form__LabelCheck} Mui__CustomCheckbox mb10 ${!checkboxStep.stages ? "disabledautomation" : ''}`}>
                    {!checkboxStep.stages ? <Tooltip className='SimpleTooltip' content={t('modal:form:import:previous_job:tooltip')} background= {'#00325A'} radius={20} padding = {8} placement  = "right" fontSize= "12px">
                    <p className={`tooltipwidthautomation d-flex Dpflex16 align-items-center`}>
                    <Checkbox
                      checked={checkboxStep.automations}
                      name={'automations'}
                      onChange={(event)=>{selectJobModalAction.checkboxChange(event, formik)}}
                      value={'automations'}
                      disabled={!checkboxStep.stages}
                      icon = {<DisabledCheckbox/>}
                      checkedIcon = {<DisabledCheckbox/>}
                      />
                      {" "}
                      {t('modal:form:import:previous_job:interview_details')}
                     </p>
                     </Tooltip>
                    : <><Checkbox
                          checked={checkboxStep.automations}
                          name={'automations'}
                          onChange={(event)=>{selectJobModalAction.checkboxChange(event, formik)}}
                          value={'automations'}
                          disabled={!checkboxStep.stages}
                          icon = {<DefaultCheckbox/>}
                          checkedIcon = {<CheckedCheckbox/>}
                          />
                          {" "}
                          {t('modal:form:import:previous_job:interview_details')}
                        </>}
                  </div>

                  <div className={`${PageStyle.SelectJob__DisplayFlex} ${FormStyle.Form__LabelCheck} Mui__CustomCheckbox mb10`}>
                    <Checkbox name={'scorecards'}
                    onChange={(event)=>{selectJobModalAction.checkboxChange(event, formik)}}
                    value={'scorecards'}
                    icon = {<DefaultCheckbox/>}
                    checkedIcon = {<CheckedCheckbox/>}
                    />
                    {" "}
                    {t('modal:form:import:previous_job:scorecards')}
                  </div>

                  <div className={`${PageStyle.SelectJob__DisplayFlex} ${FormStyle.Form__LabelCheck} Mui__CustomCheckbox`}>
                    <Checkbox name={'sharing'}
                    onChange={(event)=>{selectJobModalAction.checkboxChange(event, formik)}}
                    value={'sharing'}
                    icon = {<DefaultCheckbox/>}
                    checkedIcon = {<CheckedCheckbox/>}
                    />
                    {" "}
                    {t('modal:form:import:previous_job:sharing')}
                  </div>
                </div>

                <div className={PageStyle.SelectJob__Footer}>
                <div className={PageStyle.SelectJob__ButtonAction}>
                            <Button buttonstyle={PageStyle.primarybtn} type="submit">
                           {t('button:import:default')}
                            </Button>
                          </div>
                </div>

              </Form>
            </div>

             )}
            </Formik>
        </div>
    </>

    }

    />
  ) : (
    ""
  );
}

export function GroupHeading(props)
{
  return(<div>
    <components.GroupHeading {...props} />
  </div>)
}